import { render, staticRenderFns } from "./HomeNewsDialog.vue?vue&type=template&id=ac3827d0&scoped=true"
import script from "./HomeNewsDialog.vue?vue&type=script&lang=js"
export * from "./HomeNewsDialog.vue?vue&type=script&lang=js"
import style0 from "./HomeNewsDialog.vue?vue&type=style&index=0&id=ac3827d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3827d0",
  null
  
)

export default component.exports